// plugins/deviceInfo.js
export default defineNuxtPlugin(async () => {    
  // 클라이언트에서만 실행
  if (import.meta.client) {
    await setProperty()
  }
})

async function setProperty(callback) {
  console.log('setProperty~');

  const userAgent = navigator.userAgent;
  const lowerUserAgent = userAgent.toLowerCase();

  // 모바일 키워드 리스트 (모두 소문자로 처리)
  const mobileKeywords = [
    "android", "iphone", "ipod", "ipad", "blackberry",
    "windows ce", "samsung", "lg", "mot", "sonyericsson",
    "iemobile", "opera mini", "crios"
  ];

  let isMobile = "N";
  let isIphone = "N";

  for (const keyword of mobileKeywords) {
    if (lowerUserAgent.includes(keyword)) {
      isMobile = "Y";
      if (keyword.startsWith("ip")) {
        isIphone = "Y";
      }
      break;
    }
  }

  // 폰지킴 App 체크 - UA 마커가 있으면 앱이 확실하므로 모바일 키워드 판정에 의존하지 않는다.
  // 여기서 놓치면 pk(네이티브 브릿지) 로드가 차단되어 앱 기능이 전부 실패한다.
  const isSafePhoneApp = !!SAFEPHONE_UA_MARKER && lowerUserAgent.includes(SAFEPHONE_UA_MARKER);
  if (isSafePhoneApp) {
    isMobile = "Y";
  }

  // 세션에 저장
  sessionStorage.setItem("isMobile", isMobile);
  sessionStorage.setItem("isIphone", isIphone);

  // 기본 커버 구분
  let coverGbnCd = isMobile === "Y" ? "MOBWEB" : "PCWEB";

  if (isMobile === "Y") {
    // uPass App 체크
    const versionMatch = lowerUserAgent.match(/passversion\/([^\s]+)/);
    const version = versionMatch?.[1] || "";

    if (version) {
      coverGbnCd = "UPASSAPP";
    }

    // kPass App 체크
    if (lowerUserAgent.includes(";pass")) {
      coverGbnCd = "KPASSAPP";
    }

    // skt App 체크 ??
  }

  if (isSafePhoneApp) {
    coverGbnCd = "SAFEPHONEAPP";
  }

  sessionStorage.setItem("coverGbnCd", coverGbnCd);

  console.log('디바이스 정보 설정 완료:', {
    isMobile,
    isIphone, 
    coverGbnCd
  });

  // 콜백 실행
  if (typeof callback === "function") {
    await callback();
  }
}